<template>
  <!-- Seaded -> Kliendid uues kujunduses: the new look. Off, the old form. -->
  <form-plate v-if="plate" />
  <loading-content v-else :loading="loading">
    <heading>
      <template v-if="formType === types.CREATE">Lisa uus klient</template>
      <template v-else-if="client">{{client.fullName}}</template>
      <!-- Only for a client that exists: Vue Router 4 refuses to build a link
           without its clientId, where Vue Router 3 drew one to nowhere. -->
      <v-btn v-if="clientId" color="primary" :to="{ name: 'client/view/info', params: { clientId: clientId }}">Vaata</v-btn>
    </heading>
    <v-row>
      <v-col col="12" md="6" xl="4">
        <card>
          <v-form ref="observer" @submit.prevent>
            <v-select
              key="type"
              :rules="[rules.required]"
              v-model="form.type"
              :items="clientTypes"
              label="Tüüp*"
              required
            />
            <v-text-field
              v-if="isCompany"
              key="title"
              :rules="[rules.required]"
              v-model="form.title"
              label="Firmanimi*"
            />
            <v-text-field
              v-if="!isCompany"
              key="firstName"
              :rules="[rules.required]"
              v-model="form.firstName"
              label="Eesnimi*"
            />
            <v-text-field
              v-if="!isCompany"
              key="lastName"
              :rules="[rules.required]"
              v-model="form.lastName"
              label="Perenimi*"
            />
            <v-text-field
              key="email"
              :rules="[rules.email('email')]"
              v-model="form.email"
              label="E-posti aadress"
            />
            <v-text-field
              key="phone"
              :rules="[rules.required]"
              v-model="form.phone"
              label="Telefon"
            />
            <v-select
              key="country"
              :rules="[rules.required]"
              v-model="form.countryId"
              :items="countries"
              item-title="title"
              item-value="id"
              label="Riik"
              required
            />
            <v-select
              key="city"
              :rules="[rules.required]"
              v-model="form.cityId"
              :items="cities"
              item-title="title"
              item-value="id"
              label="Linn"
              required
            />
            <v-text-field
              key="address"
              v-model="form.address"
              label="Aadress"
            />
            <v-text-field
              key="postcode"
              v-model="form.postcode"
              label="Postiindeks"
            />
            <autocomplete
              v-if="isCompany"
              key="contact"
              v-model="form.contact"
              label="Kontakt"
              item-text="fullName"
              item-value="id"
              searchMethod="searchClients"
              itemKey="clients"
            >
              <template v-if="!(form.contact && form.contact.id)" #append-inner><contact-add :typed="form.contact" :country-id="form.countryId" :city-id="form.cityId" @created="form.contact = $event" /></template>
            </autocomplete>
            <v-checkbox
              key="problematic"
              v-model="form.problematic"
              label="Problemaatiline"
              type="checkbox"
            />
            <v-textarea
              v-if="form.problematic"
              key="problematicNote"
              v-model="form.problematicNote"
              label="Põhjus"
              hint="Näevad kontor ja tehnikud. Klient portaalis ei näe."
              persistent-hint
              rows="2"
              auto-grow
              counter="1000"
              maxlength="1000"
            />
            <v-btn :loading="submitLoading" color="success" @click="_submit()">Salvesta</v-btn>
          </v-form>
        </card>
      </v-col>
    </v-row>
  </loading-content>
</template>

<script>
import api from '@/api'
import formMixin from '@/plugins/formMixin'
import rules from '@/plugins/rules'
import { mapState } from 'vuex'
import FormPlate from './FormPlate.vue'

const types = {
  CREATE: 'create',
  UPDATE: 'update'
}

const clientTypes = {
  PRIVATE: 1,
  COMPANY: 2
}

const empty = {
  type: 1,
  firstName: '',
  lastName: '',
  title: '',
  email: '',
  phone: '',
  address: '',
  postcode: '',
  countryId: 1,
  cityId: 1,
  contact: undefined,
  problematic: false,
  problematicNote: '',
  key: false
}

export default {
  components: { FormPlate },
  mixins: [ formMixin ],
  data () {
    return {
      rules,
      client: undefined,
      countries: [],
      cities: [],
      form: {
       ...empty
      },
      clientTypes: [{
        value: clientTypes.PRIVATE,
        text: 'Eraisik'
      }, {
        value: clientTypes.COMPANY,
        text: 'Firma'
      }]
    }
  },
  computed: {
    ...mapState(['features']),
    plate () {
      return !!(this.features && this.features.clientPlate)
    },
    clientId () {
      return this.$route.params.clientId
    },
    formType () {
      return this.clientId ? types.UPDATE : types.CREATE
    },
    isCompany () {
      return this.form.type === clientTypes.COMPANY
    },
    successMessage() {
      switch (this.formType) {
        case types.CREATE:
          return 'Uus klient edukalt loodud'
        default:
          return 'Klient edukalt uuendatud'
      }
    }
  },
  watch: {
    async clientId () {
      this.refresh()
    },
    async 'form.countryId' (countryId) {
      const cityId = this.form.cityId
      this.form.cityId = undefined
      this.cities = []
      this.cities = await api.getCities(countryId)
      if (this.cities.find(({ id }) => id === cityId)) {
        this.form.cityId = cityId
      }
    }
  },
  methods: {
    async refresh () {
      this.form = { ...empty }
      // The new look loads its own client.
      if (this.plate || !this.clientId) {
        return
      }
      this.loading = true
      this.client = undefined
      const { client } = await api.getClient(this.clientId)
      this.client = client
      Object.assign(this.form, client)
      this.loading = false
    },
    async handleForm () {
      const request = {
        ...this.form,
        // null empties it: left out, the server keeps the stored Kontakt.
        contactId: this.isCompany ? (this.form.contact && this.form.contact.id || null) : undefined
      }
      if (this.formType === types.CREATE) {
        const { client } = await api.createClient(request)
        this.$router.push({ name: 'client/view/info', params: { clientId: client.id }})
      } else {
        await api.updateClient(this.clientId, request)
        this.$router.push({ name: 'client/view/info', params: { clientId: this.clientId }})
      }
      return true
    }
  },
  mounted () {
    this.refresh()
    if (this.plate) return
    api.getCountries().then(countries => {
      this.countries = countries
    })
    api.getCities(1).then(cities => {
      this.cities = cities
    })
  }
}
</script>